export default __webpack_public_path__ + "static/media/Red_Dot.9dbd3370.svg";